/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TournamentGroup = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        matches: {
            type: 'array',
            contains: {
                type: 'MatchTournamentMinimal',
            },
            isRequired: true,
        },
        matchSectionAmount: {
            type: 'number',
            isRequired: true,
        },
        matchSectionDurationMinutes: {
            type: 'number',
            isRequired: true,
        },
        matchSectionPauseDurationMinutes: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
